import { render, staticRenderFns } from "./TheLoginForm.vue?vue&type=template&id=e4731ef4"
import script from "./TheLoginForm.vue?vue&type=script&lang=js"
export * from "./TheLoginForm.vue?vue&type=script&lang=js"
import style0 from "./TheLoginForm.vue?vue&type=style&index=0&id=e4731ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QIcon,QToggle,QBtn});
